<template>
        <el-dialog
                :close-on-click-modal="false"
                width="800px"
                top="1px"
                :title="row.serveName+'-服务监控'"
                :visible.sync="show">
            <div style="width: 100%; max-height:calc(100vh - 150px)" v-loading="loading" >
                <div class="area-item"  >
                    <div class="area-title">服务趋势</div>
                    <div >
                        <div id="echartsLine" :style="{width: '100%', height: '320px'}"></div>
                    </div>
                </div>
                <div class="area-item" >
                    <div class="area-title">效能监控</div>
                    <div class="progress">
                        <div class="progress-item">
                            <div class="left">
                              申请数
                            </div>
                            <div class="center">
                                <el-progress :percentage="100" color="#cccccc"></el-progress>
                            </div>
                            <div class="right" v-text="resData.applyNum">
                            </div>
                        </div>
                        <div class="progress-item">
                            <div class="left" >
                                进行中
                            </div>
                            <div class="center">
                                <el-progress color="#409EFF" :percentage="resData.applyNum?(resData.activeNum*100/resData.applyNum):0" ></el-progress>
                            </div>
                            <div class="right"  v-text="resData.activeNum">
                            </div>
                        </div>
                        <div class="progress-item">
                            <div class="left">
                                已终止
                            </div>
                            <div class="center">
                                <el-progress  color="#F56C6C"  :percentage="resData.applyNum?(resData.terminateNum*100/resData.applyNum):0"></el-progress>
                            </div>
                            <div class="right" v-text="resData.terminateNum">
                            </div>
                        </div>
                        <div class="progress-item">
                            <div class="left" >
                                已结办
                            </div>
                            <div class="center">
                                <el-progress  color="#67C23A"  :percentage="resData.applyNum?(resData.finNum*100/resData.applyNum):0"></el-progress>
                            </div>
                            <div class="right"  v-text="resData.finNum">
                            </div>
                        </div>

                    </div>
                </div>

            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="submitForm('ruleForm')" type="primary">提 交</el-button>
                <el-button @click="show = false">取 消</el-button>
            </div>

        </el-dialog>
</template>

<script>
    import {
        singleServeStatic
    } from '@/api/bpmnApi/bpmn';
    export default {
        name: "useServeInfoDialog",
        components: {

        },
        props: [],
        data() {
            return {
                show:false,
                loading:false,
                row:{},
                resData:{}

            };
        },
        computed: {

        },
        mounted(){
        },
        methods: {
            submitForm(){

            },

            // 显示弹框
            dialogShow (row) {
                this.show=true;
                this.row=row;
                let date = new Date();
                let year = date .getFullYear();
                let processDefId=row.processDefId||"obj_afbefa5389854e36b09749810b461dd4"
                this.singleServeStaticFn({year,processDefId})
            },
            singleServeStaticFn(params){
                this.loading=true;
                singleServeStatic(params).then(({data})=>{
                    this.loading=false;
                    if(data.code == 0){
                        this.setEchart(data.data.chartData||[]);
                        this.resData=data.data||{}
                    }
                }).catch(err=>{
                    this.loading=false;
                })
            },
            setEchart(data){
                let labelList=data.map(i=>(i.name||''))
                let dealNumList=data.map(i=>i.dealNum)
                let applyNumList=data.map(i=>i.applyNum)
                let dom = document.getElementById("echartsLine");
                let myChart = this.echarts.init(dom);
                let option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['服务次数', '服务人数'],
                        bottom:10,//legend距离canvas上面的距离

                    },
                    grid: {
                        left: '10%',
                        width:'80%',
                        containLabel: false
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: labelList
                    },
                    yAxis: {
                        name:'数量',
                    },
                    series: [
                        {
                            name: '服务次数',
                            type: 'line',
                            smooth: true,
                            lineStyle:{
                                color:'#81D3CB'
                            },
                            color: '#81D3CB',
                            data: applyNumList
                        },
                        {
                            name: '服务人数',
                            type: 'line',
                            smooth: true,
                            color: '#99ACFF',
                            lineStyle:{
                                color:'#99ACFF'
                            },
                            data:dealNumList
                        }
                    ]
                };
                if (option && typeof option === "object") {
                    myChart.setOption(option, true);
                }
            },

        },
        filters: {}
    };
</script>

<style scoped lang="less">
    .area-item{
        background: #F5F5F5;
        padding: 10px 0;
        margin-bottom: 10px;
        .area-title{
            height: 20px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #064576;
            line-height: 20px;
            margin-bottom: 10px;
            border-left: 3px solid #064576;
            padding-left: 15px;
        }
        .progress{
            overflow: hidden;
            >.progress-item{
                padding: 12px 0;
                padding-left: 10px;
                width: 50%;
                float: left;
                display: flex;
                .left{
                    width: 60px;
                    text-align: center;
                }
                .center{
                    flex: 1;
                    /deep/.el-progress-bar__outer{
                        height: 8px!important;
                        margin-top: 4px;
                    }
                }
                .right{
                    width: 60px;
                }
            }
        }
    }


</style>
